import { MapStyle } from "./enums/map-style.enum";

export interface MapVisualThemeConfig {
  polygonFillOpacity: number;
  polygonLineOpacity: number;
  labelTextColor: string;
  labelHaloColor: string;
  labelHaloWidth: number;
}

export const MAP_VISUAL_THEME_CONFIG: Record<MapStyle, MapVisualThemeConfig> = {
  [MapStyle.STREETS]: {
    polygonFillOpacity: 0.2,
    polygonLineOpacity: 1,
    labelTextColor: "#0F172A",
    labelHaloColor: "rgba(255, 255, 255, 0.95)",
    labelHaloWidth: 1.1,
  },
  [MapStyle.SATELLITE]: {
    polygonFillOpacity: 0.3,
    polygonLineOpacity: 0.98,
    labelTextColor: "#FFFFFF",
    labelHaloColor: "rgba(0, 0, 0, 0.85)",
    labelHaloWidth: 1.4,
  },
  [MapStyle.DATA_VIZ]: {
    polygonFillOpacity: 0.2,
    polygonLineOpacity: 1,
    labelTextColor: "#0F172A",
    labelHaloColor: "rgba(255, 255, 255, 0.95)",
    labelHaloWidth: 1.1,
  },
  [MapStyle.DATA_VIZ_LIGHT]: {
    polygonFillOpacity: 0.2,
    polygonLineOpacity: 1,
    labelTextColor: "#0F172A",
    labelHaloColor: "rgba(255, 255, 255, 0.95)",
    labelHaloWidth: 1.1,
  },
  [MapStyle.DATA_VIZ_DARK]: {
    polygonFillOpacity: 0.24,
    polygonLineOpacity: 0.92,
    labelTextColor: "#F5F7FA",
    labelHaloColor: "rgba(0, 0, 0, 0.72)",
    labelHaloWidth: 1.3,
  },
  [MapStyle.HYBRID]: {
    polygonFillOpacity: 0.26,
    polygonLineOpacity: 0.95,
    labelTextColor: "#FFFFFF",
    labelHaloColor: "rgba(0, 0, 0, 0.82)",
    labelHaloWidth: 1.35,
  },
};

export function getMapVisualThemeByStyle(style: MapStyle): MapVisualThemeConfig {
  return MAP_VISUAL_THEME_CONFIG[style] ?? MAP_VISUAL_THEME_CONFIG[MapStyle.DATA_VIZ];
}
